export default function() {
    const self = this

    self.getJob()

    self.$root.$on('openMessage', () => {
        self.showMessages = true
    })

    if (self.$route.params.messages) {
        self.showMessages = true
    }
}
